module.exports = __webpack_public_path__ + "img/logo.80ceb72e.png";